
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.5 4a7.5 7.5 0 00-6.676 10.92c.126.246.146.532.056.793L4.629 19.33l3.525-1.27a1.01 1.01 0 01.818.06A7.5 7.5 0 1012.5 4zM3 11.5a9.5 9.5 0 115.43 8.587L3.36 21.913a1.01 1.01 0 01-1.297-1.28l1.794-5.188A9.469 9.469 0 013 11.5z","fill":"#04080E"}})])
          )
        }
      }
    